import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Difference from "@/components/site/Difference";
import HowItWorks from "@/components/site/HowItWorks";
import Programs from "@/components/site/Programs";
import Technology from "@/components/site/Technology";
import Founders from "@/components/site/Founders";
import Results from "@/components/site/Results";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    // Anchor smooth-scroll via Lenis
    const handleAnchor = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id.length <= 1) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", handleAnchor);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", handleAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App relative min-h-screen bg-[#050505] text-white antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#fff",
            borderRadius: 0,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "12px",
          },
        }}
      />
      <Header />
      <main>
        <Hero />
        <Difference />
        <HowItWorks />
        <Programs />
        <Technology />
        <Founders />
        <Results />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
